import { Component } from '@angular/core';
import { LoginService } from '../../services/frontdoor/login.service';

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrl: './reset.component.scss'
})
export class ResetComponent {
  code = '';
  newPassword = '';
  showPassword = false;

  constructor(private loginService: LoginService) {}

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  onReset() {
    if (!this.code || !this.newPassword) {
      alert('Please enter code and new password.');
      return;
    }

    this.loginService.reset(this.code, this.newPassword).subscribe(res => {
      if (res.success) {
        alert('Password updated successfully. You may now login with your new password.');
      } else {
        alert(res.message);
      }
    }, err => {
      console.error(err);
      alert('Server error');
    });
  }
}

